import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEyeSolidIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M21.8 11.2c-2-3.3-5.6-5.5-9.8-5.5-4.2 0-7.8 2.2-9.8 5.5a1.6 1.6 0 0 0 0 1.6c2 3.3 5.6 5.5 9.8 5.5 4.2 0 7.8-2.2 9.8-5.5a1.6 1.6 0 0 0 0-1.6ZM12 16.7A9.7 9.7 0 0 1 3.7 12a9.6 9.6 0 0 1 7.5-4.6 2 2 0 0 1-1.4 3.3c-1.1 0-2-1-2-2-.3.7-.5 1.4-.5 2.2 0 2.6 2 4.7 4.7 4.7A4.7 4.7 0 0 0 15.8 8c1.9.8 3.5 2.1 4.5 3.9a9.7 9.7 0 0 1-8.3 4.7Z" })
});
export default SvgEyeSolidIcon;
